module.exports = __webpack_public_path__ + "static/media/S (160).9d66be2b.jpg";